import {
	axiosErrorHandler,
	get,
	post,
	put,
} from 'models/shared/helpers/axiosInstance';
import { PaginatedDocuments } from 'models/shared/types/pagination';
import { buildPathWithQueryParams } from 'models/shared/helpers/utils';
import { imagesDto } from 'models/inventory/interfaces/vehicle.interface';
import {
	CreateVehicleDto,
	Vehicle,
	VehicleFilterDto,
	UpdateVehicleDto,
} from '../interfaces/vehicles.interface';

const baseVehiclePath = '/v1/vehicles';

export const fetchVehicles = async (dto: VehicleFilterDto) => {
	try {
		const res = await get<PaginatedDocuments<Vehicle>>(
			buildPathWithQueryParams(baseVehiclePath, dto),
		);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchVehicle = async (id: string) => {
	try {
		const url = `${baseVehiclePath}/${id}`;
		const res = await get<Vehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchVehicleByInternalId = async (internalId: string) => {
	try {
		const url = `${baseVehiclePath}/internal-id/${internalId}`;
		const res = await get<Vehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const fetchVehicleByTile = async (tileId: string) => {
	try {
		const url = `${baseVehiclePath}/tile/${tileId}`;
		const res = await get<Vehicle>(url);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const createVehicle = async (
	values: CreateVehicleDto,
	image?: imagesDto,
) => {
	try {
		const data = new FormData();
		if (image) {
			data.append('image', image.file);
		}

		Object.keys(values).forEach((k) => {
			const value = values[k as keyof CreateVehicleDto];
			if (value !== undefined) {
				data.append(k, value as string);
			}
		});
		const res = await post<Vehicle>(`${baseVehiclePath}`, data, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};

export const updateVehicle = async (
	values: UpdateVehicleDto,
	id: string,
	image?: imagesDto,
) => {
	try {
		const data = new FormData();
		if (image?.file) {
			data.append('image', image.file);
		}

		Object.keys(values).forEach((k) => {
			const value = values[k as keyof UpdateVehicleDto];
			if (value !== undefined) {
				data.append(k, value as string);
			}
		});
		const res = await put<Vehicle>(`${baseVehiclePath}/${id}`, data, {
			headers: { 'Content-Type': 'multipart/form-data' },
		});
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
